import { put, call, delay, takeEvery } from 'redux-saga/effects';
import * as actions from './VTOActions';
import { getWorkLoc,
    getOffersData,
    getOfferDetailedData ,
    submitOffersBatch,
    submitRequest,
    getEmployeeRequests,
    getEmployeeShift,
    getRequestsAdminBundle,
    submitConfirmRequest,
    updateSlotsReq,
    updateOfferStatusReq,
    submitReqResolution,
    getChangeLogVTO,
    getStationListVTO,
    submitEditCutOffData,
    getVtoForecast,
    getVtoForecastIntervals,
    getVtoPotentialSavings,
} from './index';
import { department } from '../../constants/constants';
import { vtoConstants } from './VTOConstants';

//should be moved to its own saga when created
export function* getMandoWorkLocations(data) {
    let station = data.params;
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getWorkLoc,
                station

            )
            if (response?.status === 200) {
                yield put(actions.getWorkLocationSuccess(response.data))
            } else {
                console.log("ERROR: " + response?.status + data.station);
            }break;
        }
        catch (error) {
            console.log("ERROR: " + error);
            break;
        }
    }
}

export function* getOffersDataSearch(data) {
    // Clear existing offers data in the store before initiating a new search
    yield put(actions.getOffersDataSuccess(null));
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getOffersData,
                data.params
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getOffersDataSuccess(response.data))
            } else {
                yield put(actions.getOffersDataFailed(response?.status))
                yield put(actions.showLoader(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            console.log("ERROR: " + error);
            break;

        }
    }
}

export function* getOfferData(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getOfferDetailedData,
                data.params
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getOfferDetailedDataSuccess(response.data))
            } else {
                yield put(actions.showLoader(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            console.log("ERROR: " + error);
            break;

        }
    }
}

export function* submitOffers(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                submitOffersBatch,
                data.params
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.createOfferSuccess({payload:data.params, response: response.data}))
            } else {
                yield put(actions.showLoader(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            console.log("ERROR: " + error);
            break;
        }
    }
}


export function* submitVTORequest(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                submitRequest,
                data.params
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.submitResponseSuccess({payload:data.params, response: response.data}))
        } else {
            yield put(actions.showLoader(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        console.log("ERROR: " + error);
        break;

    }
    }
    
}

export function* getEmpRequestsBatch(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getEmployeeRequests,
                data.params
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.getEmpReqSuccess(response.data))
        } else {
            yield put(actions.showLoader(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        yield put(actions.showError(error))
        console.log("ERROR: " + error);
        break;

    }
    }
}

export function* submitConfirmRequestData  (data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                submitConfirmRequest,
                data.params
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.submitConfirmRequestSuccess(true))
            yield put(actions.setActionSuccess(true))
        } else {
            yield put(actions.showLoader(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        console.log("ERROR: " + error);
        break;

    }
    }
}


//SHOULD be moved to its own saga when created
export function* getEmployeeShiftData(data) {
    const {station, empId, shiftStartDate,shiftEndDate} = data.params;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getEmployeeShift,
                empId,
                station,
                shiftStartDate,
                shiftEndDate
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.getEmployeeShiftSuccess(response.data))
        } else {
            yield put(actions.showLoader(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        console.log("ERROR: " + error);
        break;

    }
    }
}

export function* getRequestsBundle(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getRequestsAdminBundle,
                data.params
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.getRequestsBundleSuccess(response.data))
        } else {
            yield put(actions.showLoader(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        yield put(actions.showError(error))
        console.log("ERROR: " + error);
        break;

    }
    }
}

export function* updateSlotsRequest(data) {
    const {offerId, station, slots} = data.params;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                updateSlotsReq,
                offerId,
                station,
                slots
            )
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.updateSlotsSuccess({response: true}))

        } else {
            yield put(actions.showLoader(false))
            yield put(actions.updateSlotsSuccess({response: false, title: response?.response?.data?.title, detail: response?.response?.data?.detail}))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        yield put(actions.showError(error))
        yield put(actions.updateSlotsSuccess({response: false, title: "Error", detail: error}))
        console.log("ERROR: " + error);
        break;

    }
    }
}

export function* updateOfferStatusRequest(data) {
    const {offerId, station, status} = data.params;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                updateOfferStatusReq,
                offerId,
                station,
                status
            )
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.updateSlotsSuccess({response: true}))

        } else {
            yield put(actions.showLoader(false))
            yield put(actions.updateSlotsSuccess({response: false, title: response?.response?.data?.title, detail: response?.response?.data?.detail}))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        yield put(actions.showError(error))
        yield put(actions.updateSlotsSuccess({response: false, title: "Error", detail: error}))
        console.log("ERROR: " + error);
        break;

    }
    }
}

export function* submitReqResolutionData(data) {
    const {offerId, employeeId, workbrainRequestId, resolveAction, resolveComments} = data.params;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                submitReqResolution,
                offerId,
                employeeId,
                workbrainRequestId,
                resolveAction,
                resolveComments
            )
        
        if (response?.status === 200) {
            yield put(actions.showLoader(false))
            yield put(actions.submitReqResolutionSuccess(true))
        } else {
            yield put(actions.showLoader(false))
            yield put(actions.submitReqResolutionSuccess(false))
            console.log("ERROR: " + response?.status );
        }break;

    }
    catch (error) {
        console.log("ERROR: " + error);
        yield put(actions.submitReqResolutionSuccess(false))
        break;

    }
    }
}

export function* getChangeLogData(data) {
    yield put(actions.showChangeLogLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getChangeLogVTO,
                data.params
            )
            if (response?.status === 200) {
                yield put(actions.showChangeLogLoader(false))
                yield put(actions.getChangeLogDataResponse(response.data))
            } else {
                yield put(actions.showLoader(false))
                yield put(actions.showChangeLogLoader(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            console.log("ERROR: " + error);
            break;
        }
    }
}

export function* getStationListData(data) {
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getStationListVTO,
                data.params
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getStationListSuccess(true))
                yield put(actions.getStationListResponse(response.data))
            } else {
                yield put(actions.showLoader(false))
                yield put(actions.getStationListSuccess(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            yield put(actions.getStationListSuccess(false))
            console.log("ERROR: " + error);
            break;
        }
    }
}

export function* submitEditCutOff(data) {
    const {offerId, station, cutoffTime, untilDepleted} = data.params;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                submitEditCutOffData,
                offerId,
                station,
                cutoffTime,
                untilDepleted
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.submitEditCutOffSuccess(true))
            } else {
                yield put(actions.showLoader(false))
                yield put(actions.submitEditCutOffSuccess(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            yield put(actions.submitEditCutOffSuccess(false))
            console.log("ERROR: " + error);
            break;
        }
    }
}

export function* getVtoForecastData(data) {
    const { station, startDate, timeFrame=["",""], roleType="", workLocations="", department } = data.data;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getVtoForecast,
                station,
                startDate,
                department,
                timeFrame,
                roleType,
                workLocations
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getForecastDataSuccess(true))
                yield put(actions.getForecastData(response.data))
            } else {
                yield put(actions.showLoader(false))
                 yield put(actions.getForecastDataSuccess(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            yield put(actions.getForecastDataSuccess(false))
            console.log("ERROR: " + error);
            break;
        }
    }
}

export function* getPotentialSavings(action) {
    const { station, date, department } = action.data;
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getVtoPotentialSavings,
                station,
                date,
                department
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getPotentialSavingsSuccess(response.data))
            } else {
                yield put(actions.showLoader(false))
                yield put(actions.getPotentialSavingsFailed())
                console.log("ERROR: " + response?.status );
            }
            break;

        }
        catch (error) {
            yield put(actions.showLoader(false))
            yield put(actions.getPotentialSavingsFailed())
            break;
        }
    }
}

export function* getVtoForecastIntervalsData(data) {
    const { station, startDate, timeFrame=["",""], roleType="", workLocations="", department } = data.data; 
    yield put(actions.showLoader(true))
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getVtoForecastIntervals,
                station,
                startDate,
                department,
                timeFrame,
                roleType,
                workLocations
            )
            if (response?.status === 200) {
                yield put(actions.showLoader(false))
                yield put(actions.getForecastIntervalsDataSuccess(true))
                yield put(actions.getForecastIntervalsData(response.data))
            } else {
                yield put(actions.showLoader(false))
                yield put(actions.getForecastIntervalsDataSuccess(false))
                console.log("ERROR: " + response?.status );
            }break;

        }
        catch (error) {
            yield put(actions.getForecastIntervalsDataSuccess(false))
            console.log("ERROR: " + error);
            break;
        }
    }
}
